module.exports = __webpack_public_path__ + "img/green_116.58414476.png";